.wrapper {
	display: contents;

	--rule-text: light-dark(var(--gray-600), var(--gray-500));
	--rule-bg: transparent;
	--rule-border: light-dark(var(--gray-400), var(--gray-800));

	&:has(:user-invalid) {
		--rule-text: var(--color-error-foreground);
		--rule-bg: var(--color-error-background);
		--rule-border: transparent;
	}

	.rule[data-valid="true"] {
		--rule-text: var(--color-success-foreground);
		--rule-bg: var(--color-success-background);
		--rule-border: transparent;
	}
}

.rule {
	color: var(--rule-text);
	background-color: var(--rule-bg);
	border: var(--size-border) solid var(--rule-border);
	padding: 0 var(--size-2);
	border-radius: var(--radius-md);
}

.list {
	display: flex;
	flex-wrap: wrap;
	gap: var(--size-2);
	font-size: var(--text-caption);
}
